import React from 'react';
import './Main_discover.css';
import { Link } from 'react-router-dom';

import Offers_main from '../../Offers/Offers_main/Offers_main.js';
import Articles_list from '../../Articles/Articles_list/Articles_list.js';

import logo from '../../../../images/logos/logo.png';


import { logEvent } from '../../../../utils/analytics';

class Main_discover extends React.Component {
    componentDidMount(){
        // amplitude
        logEvent('discover: view main page', { source: 'discover' })
    }

    render () {
        return (
            <main className='main_discover'>
                <Offers_main 
                    active_header={this.props.active_header}
                />
                <Articles_list 
                    active_header={this.props.active_header}
                />

                {/*<Link to='/' className='home_bottom_logo'>*/}
                <a href='https://www.greatestgiftapp.com' className='home_bottom_logo'>
                    <div className='home_bottom_logo'>
                        <img src={logo}/>
                    </div>
                </a>
                {/*</Link>*/}
                <div className='buffer'></div>
            </main>
        );
    }
}

export default Main_discover;